module.exports = __webpack_public_path__ + "img/punch-first-block-bg.e6c19c8f.png";